export const IsEnvDevelpomentOrStaging = () => {
    const href = window.location.href;

    if (href.includes('localhost') || href.includes('test')) return true;

    return false;
};
